export const COURSE_DEFAULT_SORT_FIELD = 'name';
export const COURSE_DEFAULT_SORT_DIRECTION = 'asc';
